var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 88,
    viewBox: "0 0 68 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.3346 29.3333H54.8346V21.875C54.8346 11 46.8763 1.29167 36.043 0.250002C23.6263 -0.916665 13.168 8.83333 13.168 21V29.3333H0.667969V87.6667H67.3346V29.3333ZM34.0013 66.8333C29.418 66.8333 25.668 63.0833 25.668 58.5C25.668 53.9167 29.418 50.1667 34.0013 50.1667C38.5846 50.1667 42.3346 53.9167 42.3346 58.5C42.3346 63.0833 38.5846 66.8333 34.0013 66.8333ZM21.5013 29.3333V21C21.5013 14.0833 27.0846 8.5 34.0013 8.5C40.918 8.5 46.5013 14.0833 46.5013 21V29.3333H21.5013Z",
    fill: "#8053EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default __webpack_public_path__ + "static/media/locked-icon.bb7ce17eda0709bba8bcb7f56f0ef431.svg";
export { ForwardRef as ReactComponent };